<script>
import VueHtml2pdf from "vue-html2pdf";
import QRCode from "qrcode";

export default {
  components: { VueHtml2pdf },

  props: {
    pdfData: {
      type: Object,
      default: () => ({}),
    },
  },

  data: (vm) => ({
    curDate: vm.$date(new Date()),
    qrCodeId: `id-${new Date().getTime()}`,
  }),

  mounted() {
    const canvas = document.getElementById(this.qrCodeId);

    let contractId = this.pdfData.contractId;
    QRCode.toCanvas(
      canvas,
      "https://admission.usat.uz/contract-info/" + contractId,
      { width: 225, height: 225 },
      (error) => {
        if (!error) {
          this.$refs.html2Pdf.generatePdf();
        }
      }
    );
  },

  methods: {
    getName(pdfData) {
      return pdfData.srok_n;
      // let yearStudy;
      // switch (pdfData.id) {
      //   case 3:
      //     if (pdfData.typeAbiturient == "SECOND_SPES") {
      //       yearStudy = "4 йил";
      //     } else {
      //       yearStudy = "5 йил";
      //     }
      //     break;
      //   case 6:
      //     if (pdfData.typeAbiturient == "SECOND_SPES") {
      //       yearStudy = "4 йил";
      //     } else {
      //       yearStudy = "5 йил";
      //     }
      //     break;
      //   case 9:
      //     if (pdfData.typeAbiturient == "SECOND_SPES") {
      //       yearStudy = "4 йил";
      //     } else {
      //       yearStudy = "5 йил";
      //     }
      //     break;
      //   case 12:
      //     if (pdfData.typeAbiturient == "SECOND_SPES") {
      //       yearStudy = "4 йил";
      //     } else {
      //       yearStudy = "5 йил";
      //     }
      //     break;
      //   /* case 15:
      //     yearStudy = "5-йил";
      //     break;*/
      //   case 18:
      //     if (pdfData.typeAbiturient == "SECOND_SPES") {
      //       yearStudy = "4 йил";
      //     } else {
      //       yearStudy = "5 йил";
      //     }
      //     break;
      //   case 23:
      //     if (pdfData.typeAbiturient == "SECOND_SPES") {
      //       yearStudy = "4 йил";
      //     } else {
      //       yearStudy = "5 йил";
      //     }
      //     break;
      //   case 26:
      //     if (pdfData.typeAbiturient == "SECOND_SPES") {
      //       yearStudy = "4 йил";
      //     } else {
      //       yearStudy = "5 йил";
      //     }
      //     break;
      //   case 29:
      //     if (pdfData.typeAbiturient == "SECOND_SPES") {
      //       yearStudy = "4 йил";
      //     } else {
      //       yearStudy = "5 йил";
      //     }
      //     break;
      //   case 32:
      //     if (pdfData.typeAbiturient == "SECOND_SPES") {
      //       yearStudy = "4 йил";
      //     } else {
      //       yearStudy = "5 йил";
      //     }
      //     break;
      //   case 13:
      //     if (pdfData.typeAbiturient == "SECOND_SPES") {
      //       yearStudy = "2 йил";
      //     } else {
      //       yearStudy = "3 йил";
      //     }
      //     break;
      //   case 14:
      //     if (pdfData.typeAbiturient == "SECOND_SPES") {
      //       yearStudy = "2 йил";
      //     } else {
      //       yearStudy = "3 йил";
      //     }
      //     break;
      //   default:
      //     if (pdfData.typeAbiturient == "SECOND_SPES") {
      //       yearStudy = "3 йил";
      //     } else {
      //       yearStudy = "4 йил";
      //     }
      //     break;
      // }
      // return yearStudy;
    },

    formatDate(firstDate) {
      if (firstDate == "1-курс") {
        return "2024 йил 29 феврал";
      } else {
        return "2024 йил 29 феврал";
      }
      /* const [year, month, day] = firstDate.split("-");
      let monthName;
      let yearName = year;
      let dayNumber = day;
      switch (month) {
        case "01":
          monthName = "январ";
          break;
        case "02":
          monthName = "феврал";
          break;
        case "03":
          monthName = "март";
          break;
        case "04":
          monthName = "апрел";
          break;
        case "05":
          monthName = "май";
          break;
        case "06":
          monthName = "июнь";
          break;
        case "07":
          monthName = "июль";
          break;
        case "08":
          monthName = "август";
          break;
        case "09":
          monthName = "сентябр";
          break;
        case "10":
          monthName = "октябр";
          break;
        case "11":
          monthName = "ноябр";
          break;
        case "12":
          monthName = "декабр";
          break;
      }
      return yearName + " йил " + dayNumber + "-" + monthName;*/
    },
  },
};
</script>

<template>
  <div style="display: none">
    <vue-html2pdf
      :enable-download="true"
      :float-layout="false"
      :show-layout="false"
      :preview-modal="false"
      :manual-pagination="true"
      :filename="pdfData.fullName"
      pdf-format="a4"
      ref="html2Pdf"
      @hasDownloaded="$emit('close')"
    >
      <section slot="pdf-content">
        <section
          class="pdf-item"
          style="
            padding: 60px 60px 55px 97px;
            color: black;
            font-size: 1em;
            text-align: justify;
          "
        >
          <section>
            <div class="_text-center">
              <b>
                Тўлов контракт асосида мутахассис тайёрлашга <br />
                КОНТРАКТ № {{ pdfData.facultyCode }}
              </b>
            </div>
            <br />
            <div
              style="
                display: flex;
                justify-content: space-between;
                padding: 0 30px;
              "
            >
              <div>
                <b> {{ pdfData.contractDate }}</b>
              </div>
              <div><b>Тошкент шаҳри</b></div>
            </div>
            <br />

            <div>
              "UNIVERSITY OF SCIENCE AND TECHNOLOGIES" маъсулияти чекланган
              жамият (кейинги ўринларда матнда "Университет" деб юритилади)
              номидан Устав асосида иш юритувчи ректор ҲАМДАМОВ АНВАР НОРОВИЧ
              бир томондан, ва {{ pdfData.fullName }} ни (кейинги ўринларда
              матнда "Талаба" деб юритилади) иккинчи томондан,
              ______________________________ ___________________, (кейинги
              ўринларда матнда "Тўловчи" деб юритилади) ___________________
              асосида иш юритувчи __________________________ иштирокида
              (биргаликда – “Тарафлар” деб аталишади) мазкур контрактни туздилар
            </div>
          </section>

          <section>
            <br />
            <div class="_text-center">
              <b>1. Контракт предмети </b>
            </div>
            <br />

            <div>
              1.1. Университет <b>{{ pdfData.educationFacultyName }}</b> таълим
              йўналиши бўйича <b>{{ pdfData.educationTypeName }}</b> шаклда
              бакалалавриат тайёрлаш дастури бўйича ўқув жараёнини (кейинги
              ўринларда “Ўқитиш”) амалга ошириш мажбуриятини ўз зиммасига олади,
              Талаба/Тўловчи Университет томонидан тасдиқланган тарифлар бўйича
              тақдим этиладиган хизматларни тўлаш мажбуриятини олади.
              <div>
                <br />
                <table width="100%">
                  <tbody>
                    <tr>
                      <th>Таълим йўналиши</th>
                      <th>Таълим босқичи</th>
                      <th>Таълим шакли</th>
                      <th>Ўқув курси</th>
                      <th>Ўқиш муддати</th>
                    </tr>
                    <tr>
                      <td>{{ pdfData.educationFacultyName }}</td>
                      <td>Бакалавр</td>
                      <td>{{ pdfData.educationTypeName }}</td>
                      <td>{{ pdfData.kurs }}</td>
                      <td>{{ getName(pdfData) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>

          <section>
            <br />
            <div class="_text-center">
              <b>2. Тарафларнинг ҳуқуқ ва мажбуриятлари: </b>
              <br />
              <b>2.1. Университет мажбуриятлари: </b>
            </div>
            <br />

            <div>
              2.1.1. Таълим бериш учун Ўзбекистон Республикасининг "Таълим
              тўғрисида"ги Қонунига мувофиқ Университет Уставида назарда
              тутилган зарур шарт-шароитларни яратиш.
              <br />
              2.1.2. Талабаларга қонун билан берилган ҳуқуқларининг эркин амалга
              оширилишини ва Университет Уставига мувофиқ мажбуриятларнинг
              бажарилишини таъминлаш.
              <br />
              2.1.3. Мутахассисни тасдиқланган ўқув режаси ва дастурларга
              мувофиқ давлат таълим стандарти талаблари даражасида тайёрлаш.
              <br />
              2.1.4. Бошланадиган ўқув йилида ўқитиш учун тўловнинг белгиланган
              миқдори тўғрисида ҳамда тўлов миқдори Университет томонидан
              ўзгартирилганда Талабага/Тўловчига ўз вақтида хабар бериш. <br />
              2.1.5. Имтиҳонларни қайта топшириш ва/ёки бошқа хизматлар учун
              қўшимча шартномаларни Талаба/Тўловчига тақдим этиш.
            </div>
            <br />
          </section>

          <section>
            <br />
            <div class="_text-center">
              <b> 2.2. Университет ҳуқуқлари: </b>
            </div>
            <br />

            <div>
              2.2.1. Талаба ва Тўловчи томонидан ўз мажбуриятларини бажарилиши
              устидан доимий мониторинг олиб бориш.
              <br />
              2.2.2. Таълим хизматлари сони ва сифатини пасайтирмаган ҳолда
              тасдиқланган ўқув машғулотлари жадвалига ўзгартиришлар киритиш,
              зарур ҳолларда ўқув жараёнини онлайн тарзда ташкил этиш,
              дарсларни, оралиқ ва якуний имтиҳонларни оффлайн ёки онлайн
              ўтказиш.
              <br />
            </div>
          </section>
        </section>

        <div class="html2pdf__page-break" />

        <section
          class="pdf-item"
          style="
            padding: 60px 60px 55px 97px;
            color: black;
            font-size: 1em;
            text-align: justify;
          "
        >
          <section>
            <div>
              2.2.3. Мазкур Контракт бўйича тўлов кечиктирилган тақдирда, Талаба
              томонидан Университет талабалари учун ўрнатилган ички-тартиб
              қоидалари бузилган тақдирда талабага интизомий чора қўллаш,
              талабанинг Ўқув биносига кириши ёки Университет ресурсларидан
              фойдаланиш ҳуқуқини чеклаш, талабани талабалар сафидан чиқариш ёки
              ўқишдан вақтинчалик четлашлаштириш бўйича қарорни қабул қилиш.
            </div>
          </section>

          <section>
            <br />
            <div class="_text-center">
              <b> 2.3. Тўловчи мажбуриятлари </b>
            </div>
            <br />

            <div>
              2.3.1. Тўловни амалга оширишда тўловнинг мақсадига қуйидагилар
              кўрсатилиши лозим:
              <b>
                талабанинг фамилияси исми ва шарифи ҳамда контрактнинг рақами ва
                тузилган санаси.
              </b>
              <br />
              2.3.2. Тўловчи мазкур Контракт бўйича шартнома мажбуриятларини
              бажариш имкониятига эга бўлмаган тақдирда, университетни ёзма
              равишда хабардор қилиши лозим. Ёзма хабарнома берилмаган тақдирда,
              Университет янги талабгор билан қўшимча контрактни расмийлаштириш
              учун ушбу Контрактни бир томонлама бекор қилиш ҳуқуқига эга
              бўлади. Агар янги тўловчи билан қўшимча контракт тузиладиган
              бўлса, Тўловчи ушбу ҳолатда Университетга даъвоси йўқлигига
              мутлақо рози бўлади.
              <br />
              2.3.3. Талаба ва Тўловчи ўзаро муносабатларини алоҳида шартлашиб
              оладилар.
              <br />
              Университет Талаба ва Тўловчи муносабатларида қатнашмайди.
              <br />
              2.3.4. Талаба ва Тўловчи бир шахс бўлиши мумкин.
            </div>
          </section>

          <section>
            <br />
            <div class="_text-center">
              <b>2.4. Талаба мажбуриятлари </b>
            </div>
            <br />

            <div>
              2.4.1. Университетнинг ўқув жараёни ва фаолиятини тартибга солувчи
              Ўзбекистон Республикаси Қонун ҳужжатлари, Университет Устави
              талабларига мувофиқ равишда таълим олиш.
              <br />
              2.4.2. Университетда амалда бўлган ички тартиб қоидалари ва
              университет низомларига, ўқув интизомига ҳамда умумэътироф этилган
              хулқ-атвор қоидаларига қатьий риоя қилиш.
              <br />
              2.4.3. Университет мол-мулкидан эҳтиёткорлик билан фойдаланиш ва
              университетга етказилган зарарни Ўзбекистон Республикаси
              қонунчилигига мувофиқ қоплаш.
              <br />
              2.4.4. Тўловчи билан биргаликда Университетнинг ҳисоб варағига
              контракт маблағларини ўз вақтида тушиши учун барча зарур
              чораларини кўриш.
              <br />
              2.4.5. Контрактни ва/ёки қўшимча шартномаларни имзолаб, бир
              нухасини {{ formatDate(pdfData.kurs) }}га қадар Университетга
              тақдим этиш.
              <br />
              2.4.6. Тарафлар томонидан келишилган бошқа шартлар ва кафолатларни
              бажариш.
              <br />
              2.4.7. Паспорт маълумотлари, манзил ва алоқа телефонлари ўзгарган
              вақтидан эьтиборан беш кун ичида режалаштириш бўлимига хабар
              бериш.
              <br />
              2.4.8. Ўқиш жараёнида ўзлаштира олмаслик ҳолатларида Университет
              тарифлари бўйича қўшимча хизматлардан фойдаланганлик учун
              тўловларни амалга ошириш.
              <br />
              2.4.9. Ўқиш даврида Ўзбекистон Республикаси ҳудудида бўлиш ва
              Университет рухсатисиз чет элга чиқмаслик.
              <br />
              2.4.10. Университетга топширилган хужжатлар, шу жумладан умумий
              ўрта ва ўрта махсус таълим тўғрисидаги ҳужжат (шаҳодатнома, диплом
              иловаси билан) ҳақиқий эканлиги учун шаҳсан жавобгар, хужжат асл
              нусхасини ўз вақтида топширилмаслиги, унинг ҳақиқий эмаслиги
              аниқланиши талабани Университет талабалари сафидан четлатишга асос
              бўла олади.
              <br />
              2.4.11. Университет биноси ва ҳудудида санитария-гигиеник ва
              техника техника хавфсизлиги талабларига (университет ҳудудида
              чекмаслик, ифлос қилмаслик, зина, эскалатор, лифт ҳамда электор
              қурилмалари: компьютор, электрон доска ва бошқа техник
              воситаларидан фойидаланиш қоидаларига) тўлиқ амал қилиш.
            </div>
          </section>
        </section>

        <div class="html2pdf__page-break" />

        <section
          class="pdf-item"
          style="
            padding: 60px 60px 55px 97px;
            color: black;
            font-size: 1em;
            text-align: justify;
          "
        >
          <section>
            <br />
            <div class="_text-center">
              <b> 2.5. Талаба ҳуқуқлари </b>
            </div>

            <div>
              2.5.1. Ўзбекистон Республикаси давлат стандартлари талабларига
              жавобберадиган билим ва кўникмаларни олиш.
              <br />
              2.5.2. Университет фаолияти муҳим масалаларини муҳокама қилишда
              иштирок этиш, ўқув жараёнининг бошқа иштирокчиларининг
              қадр-қимматини камситмаган ҳолда ўз фикрларини эркин ва очиқ ифода
              этиш.
              <br />
              2.5.3. Фанларни ўзлаштиришда турли ҳил қийинчиликлар юзага
              келганда, Университет ўқитувчилари ва ходимлари томонидан ёрдам
              олиш.
            </div>
          </section>

          <section>
            <br />
            <div class="_text-center">
              <b> 3. Ҳисоб-китоб қилиш тартиби </b>
            </div>

            <div>
              3.1. 2023-2024 ўқув йили учун белгиланган умумий тўлов ҳақи
              <b>{{ pdfData.summ }}</b> сўмни ташкил этади.
              <br />
              3.2. Университет хизматлар нархини ўзгартириш ҳуқуқини ўзида
              сақлаб қолади. Бундай ҳолатда Тарафлар қўшимча келишув тузадилар.
              <br />
              3.3. Ўқиш учун тўлов қуйидаги тартибда амалга оширилади:
              <br />
              3.3.1. тўлов ҳақининг камида 50 фоиз миқдорида қисмини
              <b>{{ formatDate(pdfData.kurs) }}гача,</b>
              <br />
              3.3.2. тўлов ҳақининг қолган қисмини
              <b>2024 йил 29 апрелгача.</b>
              <br />
              3.4. Тўлов амалга оширилган кун деб Университет банк ҳисобига
              тушган кун эътироф этилади.
              <br />
              3.5. Талабанинг истагига кўра, 3.1. бандда кўрсатилган ўқиш учун
              тўлов суммаси 3.3. бандда кўрсатилган муддатлардан аввал тўланиши
              мумкин.
              <br />
              3.6. 3.3. бандда кўрсатилган тўлов шартлари бузилган тақдирда,
              Университет Талабани талабалар сафидан чиқаришга ҳақли.
              <br />
              3.7. Талаба Университет ташаббуси билан талабалар сафидан
              чиқарилганда, аввалги тўлаган пул маблағлари қайтарилмайди
            </div>
          </section>

          <section>
            <br />
            <div class="_text-center">
              <b> 4. Контрактни бекор қилиш </b>
            </div>

            <div>
              4.1. Контракт қуйидаги ҳолларда бекор қилиниши мумкин:
              <br />
              4.1.1. Тарафларнинг ўзаро розилиги билан.
              <br />
              4.1.2. Талаба Университетнинг ички тартиб қоидаларини бузганлиги
              сабабли талабалар сафидан четлаштирилганда.
              <br />
              4.1.3. Тарафлардан бирининг контракт шартларини бажармаганида.
              <br />
              4.1.4. Узрли сабаблар билан таълим олувчининг шахсий ташаббусига
              кўра.
              <br />
              4.1.5. Университет ёки тўловчи ташкилот тугатилганида (ушбу ҳолда
              янги контракт расмийлаштирилади).
              <br />
              4.1.6. Талаба Университетдан четлаштирилганда Университет
              бухгалтерияси билан ўзаро ҳисоб - китоблар яъни қарзидорликлар
              қоплангандагина Ўқув бўлими томонидан талабага тегишли ҳужжатлар
              қайтарилади.
            </div>
          </section>

          <section>
            <br />
            <div class="_text-center">
              <b> 5. Қўшимча шартлар </b>
            </div>

            <div>
              5.1. Тарафларнинг жавобгарлиги амалдаги қонунчилик, ушбу контракт,
              Университет Устави, ички тартиб қоидалари, Университет
              раҳбариятининг бўйруқлари асосида белгиланади.
              <br />
              5.2. Тарафларга боғлиқ бўлмаган ҳолатларда (форс-мажор), яъни
              табиий офатлар, уруш ҳаракатлари, иш ташлаш ва х.к. юз берганда,
              агар тарафлардан бири шу ҳодиса туфайли контракт шартларини бажара
              олмаса, тарафга нисбатан жавобгарлик чоралари кўрилмайди.
              Форс-мажор ҳодисаси юз бергани ва шу сабабли шартнома шарти
              бажарилиши имконияти йўқлиги хужжат билан тасдиқланган бўлиши
              керак. Талабанинг Интернетга уланиш имконияти йуклиги форс-мажор
              ҳолати ҳисобланмайди.
            </div>
          </section>
        </section>

        <div class="html2pdf__page-break" />

        <section
          class="pdf-item"
          style="
            padding: 60px 60px 40px 97px;
            color: black;
            font-size: 1em;
            text-align: justify;
          "
        >
          <section>
            <div>
              5.3.. Талабанинг талабалар сафидан четлаштирилиши
              Тўловчини/Талабани Университет томонидан тақдим этилган таълим
              хизматлари учун тўловни амалга ошириш мажбуриятидан озод этмайди.
              <br />
              5.4. Талабанинг академик қарздорлиги бўлган тақдирда, қайта
              ўқитиладиган фанлар ва кредитларнинг сонидан келиб чиққан ҳолда,
              Контракт тўловининг тегишли қисми Тўловчи/Талаба томонидан
              ўрнатилган тартибда Университетга тўланади.
              <br />
              5.6. Талабани курсдан курсга кўчириш, ўқишни кўчириш ва тиклаш,
              талабалар сафидан четлаштириш ҳамда таълим муассасасини битириш
              тўғрисидаги ва бошқа тегишли буйруқларга мувофиқ (ўқиган даврига
              мутаносиб равишда) университет ўз мажбуриятларини бажарганлигини
              асосаланади. Талаба (Тўловчи) билан счёт-фактура ва далолатномалар
              тузилмайди.
              <br />
              5.7. Ушбу Контракт тарафлар уни имзолаган кундан бошлаб кучга
              киради ва тўлиқ ижро этилгунга қадар амалда бўлади.
              <br />
              5.8. Тарафлар ўртасида пайдо бўладиган низолар тарафларнинг ўзаро
              келишувларига асосан, бундай келишувга эришилмаган тақдирда
              Ўзбекистон Республикасининг амалдаги қонунларида белгиланган
              тартибда ҳал этилади.
            </div>
          </section>

          <section>
            <br />
            <div class="_text-center">
              <b> Тарафларнинг юридик манзиллари: </b>
            </div>

            <footer>
              <section class="rek-block">
                <p>
                  <b>Тўлов олувчи:</b><br />
                  "UNIVERSITY OF SCIENCE AND<br />
                  TECHNOLOGIES” МЧЖ<br />
                  Манзил: Тошкент шаҳри, Чилонзор<br />
                  тумани, Дийдор кўчаси, 71-уй <br />
                  Телефон: +99878-888-38-88 <br />
                  Университетнинг банк реквизитлари:<br />
                  Ҳ/р: 2020 8000 1054 4966 3001 <br />
                  "HAMKORBANK" АТБ БОШ ОФИС,<br />
                  АНДИЖОН Ш., МФО: 00083, СТИР: 308956140<br />
                  ОКЭД: 85420<br />
                </p>
                <p>
                  Талабанинг Ф.И.Ш.:<br />
                  _________________________________<br />
                  _________________________________<br />
                  Паспорт серияси ва рақами:_______<br />
                  №_______________________________ <br />
                  Қачон ва ким томонидан берилган: <br />
                  “_____”_____________ ______ йилда<br />
                  _________________________________<br />
                  _______________тумани / шаҳар ИИБ<br />
                  Почта манзили:___________________<br />
                  _________________________________<br />
                  _________________________________<br />
                  Телефон: ________________________<br />
                  Талаба имзоси: __________________<br />
                  Ф.И.О: __________________________<br />
                </p>
              </section>
              <section class="sign">
                <img src="../assets/sign.png" alt="" />
              </section>

              <section class="rek-block rek-block2">
                <canvas :id="qrCodeId" />

                <p>
                  Корхона/Ташкилот номи____________<br />
                  _________________________________<br />
                  Почта манзили:___________________<br />
                  _________________________________<br />
                  _________________________________<br />
                  Ҳ/Р:_____________________________<br />
                  Банк:____________________________<br />
                  МФО:_____________________________<br />
                  СТИР:____________________________<br />
                  Директор __________________<br />
                  М.Ў<br />
                </p>
              </section>
            </footer>
          </section>
        </section>
      </section>
    </vue-html2pdf>
  </div>
</template>

<style scoped lang="scss">
._text-center {
  text-align: center;
}

table,
th,
td {
  border: 0.5px solid black;
  border-collapse: collapse;
}

th,
td {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 10px;
}

footer {
  position: relative;
  margin-bottom: 50px;

  .rek-block {
    margin-top: 25px;
    display: flex;
    justify-content: space-between;
  }
  .rek-block2 {
    margin-top: 115px;
  }

  .rek-block p {
    text-align: justify;
  }

  .sign {
    position: absolute;
    width: 350px;
    left: 0;
    top: 200px;

    height: auto;
  }

  .sign img {
    width: 100%;
  }
}
</style>
